// @flow

import Game from '@/lib/game';
import UnitTemplates from '@/lib/unit_templates';

export default class {
  game: Game;

  constructor(game: Game) {
    this.game = game;
  }

  // 現在許容しているユーザーアクション
  // do('seed', {x: number, y: number, seedName: 'd_tree1_seed'})
  do(actionName: string, conditions?: { [string]: any }) {
    switch (actionName) {
      case 'seed': {
        const { x, y, seed } = conditions || {};
        return this._seed(x, y, seed);
      }
      case 'cut': {
        const { x, y } = conditions || {};
        return this._cut(x, y);
      }
      default:
        throw 'Undefined action';
    }
  }

  _seed(x: number, y: number, seed: UnitTemplate) {
    const cell = this.game.findCell(x, y);
    if (!cell || !seed) return;
    const reduceResult = this.game.assetManager.reduceUnit(seed);
    if (reduceResult === false) return;

    return cell.addUnit(seed);
  }

  _cut(x: number, y: number) {
    const value = this.game.cellManager.valuate(x, y);
    this.game.cellManager.removeUnits(x, y);
    this.game.assetManager.addGold(Math.round(value));
  }
}



// WEBPACK FOOTER //
// ./src/lib/user_action/user_action.js